module.exports = __webpack_public_path__ + "img/ZAoriginal.adac72d1.svg";